import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    CButton,
    CCol,
    CForm,
    CFormInput,
    CInputGroup,
    CInputGroupText,
    CRow,
    CAlert,
    CImage,
    CFormFeedback,
    CSpinner,
} from '@coreui/react';

import CIcon from '@coreui/icons-react';
import { cilEnvelopeClosed } from '@coreui/icons';
import * as actions from '../../store/actions/index';
import bgimage from '../../assets/Images/logo_black.png';

class ForgotPassword extends Component {
    state = {
        EmailAddress: "",
        validated: false,
        showSuccess: false,
        successMessage: "",
        showError: false,
        errorMessage: "",
        loading: false, 
    };

    handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === true) {
            try {
                const response = await this.props.onforgotpass(this.state.EmailAddress);
                if (response.type === "AUTH_SUCCESS") {
                    this.setState({
                        showSuccess: true,
                        successMessage: response.data,
                        showError: false,
                        errorMessage: "",
                        EmailAddress: "", 
                    });
                    setTimeout(() => {
                        this.setState({ showSuccess: false, successMessage: "" });
                    }, 5000);
                } else {
                    this.setState({
                        showError: true,
                        errorMessage: response.data || 'An error occurred, please try again.',
                        showSuccess: false,
                        successMessage: "",
                    });
                    setTimeout(() => {
                        this.setState({ showError: false, errorMessage: "" });
                    }, 5000);
                }
            } catch (error) {
                this.setState({
                    showError: true,
                    errorMessage: 'Something went wrong. Please try again later.',
                    showSuccess: false,
                    successMessage: "",
                });
                setTimeout(() => {
                    this.setState({ showError: false, errorMessage: "" });
                }, 5000);
            }
        }  else {
            this.setState({ validated: true });
        }
    };

    handleChange = (event) => {
        this.setState({ EmailAddress: event.target.value });
    };

    render() {
        const { showError, errorMessage, showSuccess, successMessage } = this.state;
        const errorPosition = { position: 'absolute' }

        return (
            <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
                <div className="lgnauth">
                    <div className="lgnform">
                        <CRow className="justify-content-center">
                            <CCol md={12}>
                                <CForm
                                    className="row g-3 needs-validation"
                                    noValidate
                                    validated={this.state.validated}
                                    onSubmit={this.handleSubmit}
                                >
                                    <h2 className="header-txt">Forgot Password</h2>
                                    <p className="emailheader-txt" style={{textAlign:"center"}}>Enter your email and we'll send you a link to reset your password</p>

                                    {showError && (
                                        <CAlert color="warning" dismissible>
                                            {errorMessage}
                                        </CAlert>
                                    )}

                                    {showSuccess && (
                                        <CAlert color="success" dismissible>
                                            {successMessage}
                                        </CAlert>
                                    )}

                                    <CInputGroup className="mb-3">
                                    <div className='single-input-field'>
                                    <CInputGroupText>
                                            <CIcon icon={cilEnvelopeClosed} />
                                        </CInputGroupText>
                                        <CFormInput
                                            id="EmailAddress"
                                            type="email"  
                                            placeholder="Enter email"
                                            value={this.state.EmailAddress}
                                            onChange={this.handleChange}
                                            required
                                        />
                                        <CFormFeedback invalid style={errorPosition}>Please enter a valid email.</CFormFeedback>
                                    </div>
                                        
                                        
                                    </CInputGroup>

                                    <CRow>
                                        <CButton color="primary" className="px-4 btnsign" type="submit">
                                            {this.props.loading ? (
                                                <CSpinner size="sm" /> 
                                            ) : (
                                                "Submit"
                                            )}
                                        </CButton>
                                    </CRow>
                                    <CRow>
                                        <CCol className="accnt-txt">
                                            <a
                                                href='/login'
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    this.setState({ loading: true });
                                                    setTimeout(() => {
                                                        this.setState({ loading: false });
                                                        window.location.href = '/login';
                                                    }, 1000);
                                                }}
                                            >
                                                <label> Back to Login </label>
                                            </a>
                                        </CCol>
                                    </CRow>
                                </CForm>
                            </CCol>
                        </CRow>
                    </div>
                    <div className="logobg">
                        <h2 className="weltxt">Welcome To</h2>
                        <CImage src={bgimage} height={'auto'} align="center" width={300} className="mainlgo" />
                        <p className="qqtxt">
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth._id !== null,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onforgotpass: (EmailAddress) => {
            return new Promise((resolve, reject) => {
                dispatch(actions.userForgot(EmailAddress))
                    .then(response => resolve(response))
                    .catch(error => reject(error));
            });
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
